// extracted by mini-css-extract-plugin
export default {"Heading":"loading-card-module__Heading__SAzjNG8"};